import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ConciergeChat from './components/feature/ConciergeChat'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <ConciergeChat />
    </BrowserRouter>
  )
}

export default App